const {h, render, Component} = require('preact');
const SpinnerView = require('../../views/common/spinner')

class ClaimsList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div class="row select-claim-menu">
        <div class="row claim-listing" data-bhw="web2018_claim_listing">
          <div id="claimContent">
            <div id="claimsTablewrapper">
              <table width="100%" class="scrollableTable">
                <tbody id="claimsTable">
                {this.props.itemsTable()}
                </tbody>
              </table>
              {this.props.isLoadingInProgress?<SpinnerView/>:null}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

module.exports = ClaimsList
